<div class="modal-header p-5">
  <h4 class="modal-title" id="modal-basic-title">Subscribe CPA Education</h4>
  <div class="btn btn-sm btn-icon btn-active-color-primary" (click)="activeModal.dismiss('Cross click')">
    <span class="svg-icon svg-icon-1" [inlineSVG]="'./assets/media/icons/duotune/arrows/arr061.svg'"></span>
  </div>
</div>
<div class="modal-body">
  <!--begin::Plans-->
  <div class="row g-5 g-xl-8">
    <!--begin::Col-->
    <!--end::Col-->
    <!--begin::Col-->
    <!-- <div class="col-xl-6">
      <div class="mx-6"> -->
    <!-- <app-payment-method></app-payment-method> -->
    <!-- <div>
          <h5 class="text-center flex-column">
            <span class="fw-bold fs-3 mb-1">Wallet Instructions</span>
          </h5>
        </div>
        <div class="card-body">
          <div class="p-2">
            <ul class="list-group fw-semibold text-gray-600">
              <li>The A8 platform deducts all app fees, AI model charges, and pay-as-you-go expenses from your
                organization’s wallet, managed by the Admins. The Master Admin can set up monthly or yearly recurring
                payment plans, as well as make instant payments, with Admins also able to make instant payments when
                needed.</li>
              <li>Since every app, AI token, and email usage is charged to your wallet, please ensure sufficient funds
                before subscribing. If the balance is insufficient, your wallet will show a negative amount, which will
                be automatically deducted once the subscription is processed.</li>
              <li>To avoid service disruptions, it’s essential to maintain a funded wallet, ideally through a recurring
                payment plan.</li>
            </ul>
          </div>
          <div class="fw-bold text-gray-700 ms-3 p-2">
            <div class="d-flex flex-row">
              <span [ngClass]="walletAmount > 0 ? 'text-primary fw-bold fs-1 me-1' : 'text-danger fw-bold fs-1 me-1'">
                {{walletAmount.toFixed(2)}}</span>
              <span>
                <span class="text-primary fw-bold fs-1">USD</span>
              </span>
              <span class="ml-3" style="margin-left: 6px;">
                <a href="javascript:void(0)" (click)="getWalletDetails()" ngbTooltip="Refresh Wallet"
                  class="btn btn-sm fw-bold btn-light-primary">
                  <i class="ki-outline ki-arrows-circle fs-6"></i></a>
              </span>
              <span class="ms-auto"><a routerLink="/app/learn/wallet/wallet" class="btn btn-sm btn-info"
                  target="_blank">Recharge
                  Wallet</a>
              </span>
            </div>
            <div class="fs-4">
              {{currentUser?.currentOrgName}}
            </div>
          </div>

          <div class="p-2 text-gray-700 fw-semibold">
            <div *ngIf="priceType=='monthly' && remainingBalance >= 0">
              You selected a monthly subscription. The amount in your wallet is
              <span [ngClass]="walletAmount > 0 ? 'text-primary fw-bold' : 'text-danger fw-bold'">
                {{ walletAmount.toFixed(2) }}
              </span>
              <span class="text-primary fw-bold">USD.</span>
              After deducting
              <span class="text-primary fw-bold">
                {{ currentUser?.appCurrency }}{{ subPrice?.monthlyAfterDiscPrice }}
              </span>
              <span>
                <span class="text-primary fw-bold">USD,</span>
              </span>
              <span> your remaining wallet balance will be
                <span [ngClass]="remainingBalance > 0 ? 'text-primary fw-bold' : 'text-danger fw-bold'">
                  {{ remainingBalance.toFixed(2) }}
                </span>
                <span class="text-primary fw-bold">USD.</span>
              </span>
            </div>

            <div *ngIf="priceType=='yearly' && remainingBalance >= 0">
              You selected a yearly subscription. The amount in your wallet is
              <span [ngClass]="walletAmount > 0 ? 'text-primary fw-bold' : 'text-danger fw-bold'">
                {{ walletAmount.toFixed(2) }}
              </span>
              <span>
                <span class="text-primary fw-bold">USD.</span>
              </span>
              After deducting
              <span class="text-primary fw-bold">
                {{ currentUser?.appCurrency }}{{ subPrice?.yearlyAfterDiscPrice }}
              </span>
              <span class="text-primary fw-bold">USD,</span>

              <span> your remaining wallet balance will be
                <span [ngClass]="remainingBalance > 0 ? 'text-primary fw-bold' : 'text-danger fw-bold'">
                  {{ remainingBalance.toFixed(2) }}
                </span>
                <span class="text-primary fw-bold">USD.</span>
              </span>
            </div>
          </div>
        </div> -->
    <!-- </div>
    </div> -->

    <div class="col-12" *ngIf="paymentMthodsData?.length > 0 || currentUser?.userType == 'HT'">
      <!--begin::Tables Widget 1-->
      <div class="mx-6">
        <!--begin::Header-->
        <div>
          <h5 class="text-center flex-column">
            <span class="fw-bold fs-3 mb-1">Choose Your Plan</span>
          </h5>
        </div>
        <!--end::Header-->

        <!--begin::Body-->
        <div class="card-body py-3">
          <div class="mt-4 mb-10 text-center" data-kt-buttons="true">
            <button *ngIf="subPrice?.yearlyPrice > 0"
              [ngClass]="priceType=='yearly' ? 'btn btn-active btn-active-light-primary active' : 'btn btn-color-gray-400 btn-active btn-active-secondary'"
              (click)="selectPrice('yearly')" data-kt-plan="annual">Yearly</button>
            <button *ngIf="subPrice?.monthlyPrice > 0"
              [ngClass]="priceType=='monthly' ? 'btn btn-active btn-active-light-primary active' : 'btn btn-color-gray-400 btn-active btn-active-secondary'"
              (click)="selectPrice('monthly')" data-kt-plan="month">Monthly</button>
            <button *ngIf="subPrice?.trialEnded == false && subPrice?.trialDays > 0 && currentUser?.userType == 'HT'"
              [ngClass]="priceType=='trial' ? 'btn btn-active btn-active-light-primary active' : 'btn btn-color-gray-400 btn-active btn-active-secondary'"
              (click)="selectPrice('trial')" data-kt-plan="annual">Trial</button>
          </div>
          <div class="row g-10 justify-content-center" *ngIf="priceType=='monthly'">
            <div class="w-100 d-flex flex-column flex-center rounded-3 bg-primary bg-opacity-5 shadow-sm p-6 m-4">
              <!--begin::Heading-->
              <div class="mb-2 mt-2 text-center">
                <!--begin::Title-->
                <h1 class="text-dark mb-5 fw-bolder" *ngIf="subPrice?.monthlyDiscount > 0">
                  {{subPrice?.monthlyDiscount}}% DISCOUNT</h1>
                <!--end::Title-->
                <!--begin::Description-->
                <!-- <div class="text-gray-400 fw-semibold mb-5">Optimal for 100+ team siz
                    <br>e and grown company</div> -->
                <!--end::Description-->
                <!--begin::Price-->
                <div class="text-center">
                  <span *ngIf="subPrice?.monthlyDiscount > 0">
                    <del class="fs-2x fw-bold ">
                      {{currentUser?.appCurrency}}{{subPrice?.monthlyPrice}}
                    </del>
                  </span>
                  <span class="fs-3x fw-bold text-primary" data-kt-plan-price-month="339"
                    data-kt-plan-price-annual="3399">{{currentUser?.appCurrency}}{{subPrice?.monthlyAfterDiscPrice}}</span>
                  <span class="fs-7 fw-semibold opacity-50">/
                    <span data-kt-element="period">Month</span></span>
                </div>
                <!--end::Price-->
                <div class="text-muted fw-semibold fs-7"><b>Note: </b>Kindly be aware
                  that all
                  prices are in USD.</div>
              </div>
              <!--end::Heading-->
              <!--begin::Features-->
              <div class="mb-5 text-gray-400 fw-semibold mb-5">
                <!--begin::Item-->
                <quill-view-html [content]="subPrice?.priceDetails"></quill-view-html>

                <!-- <div class="d-flex align-items-center mb-5">
                    <span class="fw-semibold fs-6 text-gray-800 flex-grow-1 pe-3">Up to 10 Active Users</span>
                    <span class="svg-icon svg-icon-1 svg-icon-success">
                      <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <rect opacity="0.3" x="2" y="2" width="20" height="20" rx="10" fill="currentColor"></rect>
                        <path
                          d="M10.4343 12.4343L8.75 10.75C8.33579 10.3358 7.66421 10.3358 7.25 10.75C6.83579 11.1642 6.83579 11.8358 7.25 12.25L10.2929 15.2929C10.6834 15.6834 11.3166 15.6834 11.7071 15.2929L17.25 9.75C17.6642 9.33579 17.6642 8.66421 17.25 8.25C16.8358 7.83579 16.1642 7.83579 15.75 8.25L11.5657 12.4343C11.2533 12.7467 10.7467 12.7467 10.4343 12.4343Z"
                          fill="currentColor"></path>
                      </svg>
                    </span>
                  </div>
                  <div class="d-flex align-items-center mb-5">
                    <span class="fw-semibold fs-6 text-gray-800 flex-grow-1 pe-3">Up to 30 Project Integrations</span>
                    <span class="svg-icon svg-icon-1 svg-icon-success">
                      <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <rect opacity="0.3" x="2" y="2" width="20" height="20" rx="10" fill="currentColor"></rect>
                        <path
                          d="M10.4343 12.4343L8.75 10.75C8.33579 10.3358 7.66421 10.3358 7.25 10.75C6.83579 11.1642 6.83579 11.8358 7.25 12.25L10.2929 15.2929C10.6834 15.6834 11.3166 15.6834 11.7071 15.2929L17.25 9.75C17.6642 9.33579 17.6642 8.66421 17.25 8.25C16.8358 7.83579 16.1642 7.83579 15.75 8.25L11.5657 12.4343C11.2533 12.7467 10.7467 12.7467 10.4343 12.4343Z"
                          fill="currentColor"></path>
                      </svg>
                    </span>
                  </div> -->
              </div>
            </div>
          </div>
          <div class="row g-10 justify-content-center" *ngIf="priceType=='yearly'">
            <div class="w-100 d-flex flex-column flex-center rounded-3 bg-primary bg-opacity-5 shadow-sm p-6 m-4">
              <!--begin::Heading-->
              <div class="mb-2 mt-4 text-center">
                <!--begin::Title-->
                <h1 class="text-dark mb-5 fw-bolder" *ngIf="subPrice?.yearlyDiscount > 0">{{subPrice?.yearlyDiscount}}%
                  DISCOUNT</h1>
                <!--end::Title-->
                <!--begin::Description-->
                <!-- <div class="text-gray-400 fw-semibold mb-5">Optimal for 100+ team siz
                    <br>e and grown company</div> -->
                <!--end::Description-->
                <!--begin::Price-->
                <div class="text-center">
                  <span *ngIf="subPrice?.yearlyDiscount > 0">
                    <del class="fs-2x fw-bold ">
                      {{currentUser?.appCurrency}}{{subPrice?.yearlyPrice}}
                    </del>
                  </span>
                  <span class="fs-3x fw-bold text-primary" data-kt-plan-price-month="339"
                    data-kt-plan-price-annual="3399">{{currentUser?.appCurrency}}{{subPrice?.yearlyAfterDiscPrice}}</span>
                  <span class="fs-7 fw-semibold opacity-50">/
                    <span data-kt-element="period">Year</span></span>
                </div>
                <!--end::Price-->
                <div class="text-muted fw-semibold fs-7"><b>Note: </b>Kindly be aware that all
                  prices are in USD.</div>
              </div>
              <!--end::Heading-->
              <!--begin::Features-->
              <div class="mb-5 text-gray-400 fw-semibold mb-5">
                <!--begin::Item-->
                <quill-view-html [content]="subPrice?.priceDetails"></quill-view-html>

                <!-- <div class="d-flex align-items-center mb-5">
                    <span class="fw-semibold fs-6 text-gray-800 flex-grow-1 pe-3">Up to 10 Active Users</span>
                    <span class="svg-icon svg-icon-1 svg-icon-success">
                      <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <rect opacity="0.3" x="2" y="2" width="20" height="20" rx="10" fill="currentColor"></rect>
                        <path
                          d="M10.4343 12.4343L8.75 10.75C8.33579 10.3358 7.66421 10.3358 7.25 10.75C6.83579 11.1642 6.83579 11.8358 7.25 12.25L10.2929 15.2929C10.6834 15.6834 11.3166 15.6834 11.7071 15.2929L17.25 9.75C17.6642 9.33579 17.6642 8.66421 17.25 8.25C16.8358 7.83579 16.1642 7.83579 15.75 8.25L11.5657 12.4343C11.2533 12.7467 10.7467 12.7467 10.4343 12.4343Z"
                          fill="currentColor"></path>
                      </svg>
                    </span>
                  </div>
                  <div class="d-flex align-items-center mb-5">
                    <span class="fw-semibold fs-6 text-gray-800 flex-grow-1 pe-3">Up to 30 Project Integrations</span>
                    <span class="svg-icon svg-icon-1 svg-icon-success">
                      <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <rect opacity="0.3" x="2" y="2" width="20" height="20" rx="10" fill="currentColor"></rect>
                        <path
                          d="M10.4343 12.4343L8.75 10.75C8.33579 10.3358 7.66421 10.3358 7.25 10.75C6.83579 11.1642 6.83579 11.8358 7.25 12.25L10.2929 15.2929C10.6834 15.6834 11.3166 15.6834 11.7071 15.2929L17.25 9.75C17.6642 9.33579 17.6642 8.66421 17.25 8.25C16.8358 7.83579 16.1642 7.83579 15.75 8.25L11.5657 12.4343C11.2533 12.7467 10.7467 12.7467 10.4343 12.4343Z"
                          fill="currentColor"></path>
                      </svg>
                    </span>
                  </div> -->
              </div>
            </div>
          </div>
          <div class="row g-10 justify-content-center" *ngIf="priceType=='trial'">
            <div class="w-100 d-flex flex-column flex-center rounded-3 bg-primary bg-opacity-5 shadow-sm p-6 m-4">
              <div class="mb-2 mt-4 text-center">
                <h1 class="text-dark mb-5 fw-bolder">Trial: {{subPrice?.trialDays}} days</h1>
                <div class="text-muted fw-semibold fs-7"><b>Note: </b>If members of your organization have already used
                  the trial period, it will no longer be available for use.
                </div>
              </div>
              <div class="w-55 mb-5 text-gray-400 fw-semibold mb-5">
                <quill-view-html [content]="subPrice?.priceDetails"></quill-view-html>
              </div>
            </div>
          </div>
          <div class="p-3 mb-2 text-center">
            <!-- <div class="form-group form-check p-2">
                <div class="form-check">
                  <label class="custom-control custom-checkbox" for="orgTerms">
                    <input class="form-check-input" type="checkbox" [(ngModel)]="termAndConditions"
                      [ngModelOptions]="{standalone: true}" id="invalidCheck" required>
                    <label class="form-check-label" for="invalidCheck">
                      Agree to
                      <a href="https://advisor8.com/privacy-and-terms.html" target="_blank" class="text-primary"> Terms </a>
                      and
                    </label>
                    <a href="https://advisor8.com/privacy-and-terms.html" target="_blank" class="text-primary"> conditions
                    </a>
    
                    <div class="invalid-feedback">
                      You must agree before submitting.
                    </div>
                  </label>
                </div>
              </div> -->

            <button type="button" class="btn btn-sm btn-primary float-right" (click)="installApp()"
              *ngIf="(priceType == 'yearly' || priceType == 'monthly')">
              Subscribe Now</button>
            <!-- <button type="button" class="btn btn-sm btn-primary float-right" 
                (click)="installApp()"
                *ngIf="(priceType == 'yearly' || priceType == 'monthly')">Check
                out</button> -->
            <button type="button" class="btn btn-sm btn-primary float-right" (click)="installApp()"
              *ngIf="priceType == 'trial'">
              INSTALL</button>
          </div>
        </div>
        <!--end::Body-->
      </div>
      <!--endW::Tables Widget 1-->
    </div>
    <div class="col-12" *ngIf="paymentMthodsData?.length == 0 && (currentUser?.userType == 'CA' || currentUser?.userType == 'CB')">
      <div class="mx-6">
        <h5 class="text-center flex-column">
          <span class="fw-bold fs-3 mb-1">No Payment Methods Available</span>
        </h5>
        <p class="text-gray-800">Before subscribing, click on 'Subscriptions' in the side menu, go to the 'Payment
          Methods' tab, and add your
          card details.</p>
      </div>
    </div>
  </div>
</div>